import { get } from "@readai/common/api";
import type { ApiHighlight } from "@readai/common/types";

export const getClips = async (sessionId: string): Promise<ApiHighlight[]> => {
  return get(`/sessions/${sessionId}/highlight-clips`, { withCreds: true });
};
